import { RouteRecordRaw } from 'vue-router'

const productVariantsRoutes: RouteRecordRaw[] = [
  {
    path: 'catalogs/:catalogId/productVariants',
    name: 'ProductVariants',
    component: () =>
      import('@/views/ProductVariants/ProductVariantsListing.vue'),
    meta: {
      title: 'Product Variants',
      bpSwitchFallback: 'Catalogs'
    }
  }
]

export default productVariantsRoutes
